import { useContext } from 'react'
import uniqid from 'uniqid'
import { LanguageContext } from '../../contexts/language'
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Projects.css'

const Projects = () => {
  const { portfolio, t } = useContext(LanguageContext)
  const { projects } = portfolio

  if (!projects.length) return null

  return (
    <section id='projects' className='section projects'>
      <h2 className='section__title'>{t.projects}</h2>

      <div className='projects__grid'>
        {projects.map((project) => (
          <ProjectContainer key={uniqid()} project={project} />
        ))}
      </div>
    </section>
  )
}

export default Projects
